import { useState, useCallback } from "react";
import { useUserProfile } from "@/hooks/useUserProfile";
import { BusinessOwnerBlockDialog } from "@/components/BusinessOwnerBlockDialog";

export const useBusinessOwnerGuard = () => {
  const { profile } = useUserProfile();
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState<string | undefined>(undefined);

  const isBusinessOnly = profile?.role === "other";

  const guard = useCallback(
    (actionLabel?: string) => {
      if (isBusinessOnly) {
        setAction(actionLabel);
        setOpen(true);
        return true;
      }
      return false;
    },
    [isBusinessOnly]
  );

  const dialog = (
    <BusinessOwnerBlockDialog open={open} onOpenChange={setOpen} action={action} />
  );

  return { isBusinessOnly, guard, dialog };
};
